import { render, staticRenderFns } from "./FiltroPeriodo.vue?vue&type=template&id=476ddbe8"
import script from "./FiltroPeriodo.vue?vue&type=script&lang=js"
export * from "./FiltroPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports